module.exports = __webpack_public_path__ + "static/media/RP-57.402fca21.pdf";